 /*
              Author: Vaishnavi
              Date: 26/11/2019
              Issue Description: Commented the search bar as it was not required. Line no 28
          */
<template>
  <div class="main-container">
    <div>
      <tl-header type="h1">
        <div>Paygroup</div>
      </tl-header>
      <div class="permission-alert-msg" v-show="!(ifTeamleaderPermission)">
        You have only view permission.
      </div>
      <toast-message
        :message="errmsg"
        type="error"
        :isToastEnable="toast"
        @close="(val) => toast = val"
      />
      <div class="noData">
        <span class="text">Click on ‘Add New’ to add new Paygroup in the following list</span>
        <button class="addnewbtn" v-if="payGroupsList.length>3" @click="addPaygroup()">
          <img src="@/assets/group-5.svg" />
          <b>Add New</b>
        </button>
      </div>
      <div :disabled="!(ifTeamleaderPermission)">
        <data-table
          :columns="paygroupColumnNames"
          :tableData="payGroupsList"
          :checkbox="false"
          :withForm="false"
          :showhistory="false"
          @editStart="initEditStart"
          @delete="deleteItem"
          :search="search"
          :deleteCondition="(record) => !record.default"
        />
      </div>
      <form-add-button
        v-if="payGroupsList.length<=3"
        v-show="showAddBtn"
        main_text="+ Add New"
        sub_text="Paygroup"
        @click="addPaygroup()"
      ></form-add-button>
      <pop-up-message
        v-if="showPopup"
        :message="'Are you sure you wish to delete ?'"
        :popupType="popupType"
        :popupHeaderMessage="'Confirm Delete'"
        @back="cancelEvent"
      >
        <template v-slot:bottomContent>
          <btn-grp>
            <popup-btn text="Cancel" type="secondary" @click="cancelEvent" />
            <popup-btn text="Delete" type="primary" @click="deleteEvent" />
          </btn-grp>
        </template>
      </pop-up-message>
      <bottom-action-container>
        <btn-skip @navClicked="continuee"></btn-skip>
        <template slot="end">
          <btn-grp>
            <btn text="Previous" type="secondary" @click="previous" />
            <btn text="Next" type="primary" @click="continuee" />
          </btn-grp>
        </template>
      </bottom-action-container>
    </div>
  </div>
</template>

<script>
import { mapState, mapActions, mapGetters } from "vuex";
import { get_axios_instance, api_variables } from "@/apis/variables.js";

export default {
  name: "Paygroup",
  data() {
    return {
      payGroupsList: [],
      toast: false,
      errmsg: "",
      isFormActive: false,
      search: "",
      showPopup: false,
      paygroupColumnNames: [
        {
          label: "Code",
          key: "code"
        },
        {
          label: "Name",
          key: "name"
        },
        {
          label: "Description",
          key: "description"
        }
      ],
      paygroupValue: false,
      role: ""
    };
  },
  computed: {
    ...mapState({
      paygroupdata: state => state.onboard.paygroup.data
    }),
    showAddBtn() {
      return !this.isFormActive;
    },
    le_id() {
      return this.$store.getters["onboard/legal_entities/legal_entity_ID"](
        this.$route.params.entity_index
      );
    },
    ifAnchor() {
      return localStorage.getItem("userRole") == "ANCHOR" ? true : false;
    },
    ...mapState("onboard/organization", {
      orgIds: state => state.id,
    }),
    ifTeamleaderPermission() {
      if(this.role === 'ADMIN') {
        return true;
      } else if(this.role === 'TEAMLEADER') {
        if(this.paygroupValue) {
          return true;
        } 
        else {
          return false;
        }
      } else {
        return false
      }

      // if(this.role === 'TEAMLEADER' || this.role === 'ADMIN') {
      //   if(this.paygroupValue) {
      //   return true;
      //   } else {
      //     return false;
      //   }
      // }
      // else {
      //  return true
      // }
    },
    ifSuperAdmin() {
      return localStorage.getItem("userRole") == "SUPERADMIN" ? true : false;
    },
  },
  activated() {
    this.fetchPaygroups();
    this.getOrgLeIdList();
  },
  methods: {
    ...mapActions({
      fetch_paygroups: "onboard/paygroup/fetchAll",
      act_changeEditMode: "onboard/paygroup/changeEditMode",
      act_update: "onboard/paygroup/update",
      act_delete: "onboard/paygroup/delete",
      act_showDefaultPopup: "onboard/paygroup/showPopup"
    }),

    ...mapActions({
      getOrgLeList: "onboard/organization/getOrgLeIdList",
    }),

    /* server call to get paygroups for current Legal Entity */
    async fetchPaygroups() {
      try {
        let res = await this.fetch_paygroups(this.le_id);
        this.payGroupsList = res.data.payload.data;
      } catch (error) {
        this.toast = true;
        this.errmsg = error;
      }
    },

    /* function to edit a paygroup */
    async initEditStart(record) {
      try {
        await this.act_changeEditMode({ editMode: true, record: record });
        this.$router.push({
          path: `/onboarding/entity/${this.$route.params.entity_index}/${this.$route.params.step_name}/modifyPaygroup`
        });
      } catch (err) {
        this.toast = true;
        this.errmsg = err;
      }
    },

    /* function to open pop-up to confirm deletion */
    deleteItem(record) {
      try {
        this.showPopup = true;
        this.popupType = "ConfirmDelete";
        this.popupMessage = "Are you sure you want to delete ?";
        this.currentRecord = record;
      } catch (error) {
        this.toast = true;
        this.errmsg = error;
      }
    },

    /* server call to delete a paygroup */
    async deleteEvent() {
      try {
        await this.act_delete([this.currentRecord, this.le_id]);
      } catch (err) {
        this.toast = true;
        this.errmsg = err;
      }
      this.showPopup = false;
    },

    /* function to go to next page */
    continuee() {
      this.$router.push({
        path: `/onboarding/entity/${this.$route.params.entity_index}/fbpConfigure`
      });
    },

    /* function to go to previous page */
    previous() {
      this.$router.push({
        path: `/onboarding/entity/${this.$route.params.entity_index}/preferences`
      });
    },

    /* function to hide the confimation pop-up */
    cancelEvent() {
      this.showPopup = false;
    },

    /* function to add a new pay group */
    async addPaygroup() {
      await this.act_changeEditMode({ editMode: false, record: {} });
      this.$router.push({
        path: `/onboarding/entity/${this.$route.params.entity_index}/${this.$route.params.step_name}/addPaygroup`
      });
    },

    async getOrgLeIdList() {
      const org = this.orgIds;
      const le = this.le_id;
      //console.log("Org:",org);
      //console.log("Le ID",le);
      let bodyParams = {};
      let  data = await this.getOrgLeList({data: {
            ...bodyParams
          }
      });
      this.role = data.data.user.userRole;
      this.paygroupValue = data.data.user.permissions.paygroup ? true : false;
      //console.log("PL-3406",data);
    }
  }
};
</script>

<style lang="scss" scoped>
.noData {
  height: 55px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  .text {
    color: #858585;
    font-size: 14px;
  }
}
.addnewbtn {
  float: right;
  margin-left: 8px;
}

.permission-alert-msg {
  background-color: #f8d7da;
  padding: 1rem 1rem;
  margin-top: 1rem;
  margin-bottom: 1rem;
  font-weight: 600;
  color: #842029;
  border: 1px solid transparent;
  border-radius: .25rem;
  border-color: #f5c2c7;
}
</style>
